import { Alert, AlertIcon, AlertDescription } from '@chakra-ui/react';

export default function ErrorMessage({ label }) {
  return (
    <Alert status="warning">
      <AlertIcon />
      <AlertDescription>{label}</AlertDescription>
    </Alert>
  );
}
